module.exports = __webpack_public_path__ + "static/undraw_browser_stats_704t.a4e45969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/graphics/undraw_browser_stats_704t.svg
// module id = 138
// module chunks = 33781710060979 35783957827783